<template>
  <article class="order_details">
    <header class="pages_title">
      <h3>订单号:{{ orderData.OrderNum }}</h3>
    </header>

    <section class="order_details_container">
      <div class="order_details_passenger_separation flex_wrap"><h3>订单详情</h3></div>
      <div class="order_details_route">
        <div class="order_details_route_info">
          <!--          <p class="">
            <span>订单类型:</span>
            <span v-if="orderData.OrderType == 1">普通业务</span>
            <span v-else-if="orderData.OrderType == 2">接送购票</span>
          </p> -->
          <p class="">
            <span>联系人 :</span>
            <span>{{ orderData.Contact }}</span>
          </p>
          <p class="" v-if="orderData.OrderType == 2">
            <span>接送地址 :</span>
            <span class="text_wrapping">{{ orderData.Address }}</span>
          </p>
          <p class="">
            <span>旅客人数 :</span>
            <span class="text_wrapping">{{ orderData.Adult + orderData.Child + orderData.Baby }}</span>
          </p>
          <p class="">
            <span>下单时间 :</span>
            <span class="text_wrapping">{{ orderData.CreateDate }}</span>
          </p>
          <p class="">
            <span>订单进度 :</span>
            <span class="text_wrapping">{{ orderState[orderData.OrderState] }}</span>
          </p>
          <p class="">
            <span>总价 :</span>
            <span class="text_wrapping">{{ orderData.TotalPrice }}元</span>
          </p>
          <p class="">
            <span>客服确认：</span>
            <span class="text_wrapping">{{ orderData.OrderCheck ? '已处理订单' : '未处理订单' }}</span>
          </p>
          <p class="">
            <span>客户备注：</span>
            <span class="text_wrapping">{{ orderData.OrderRemarks }}</span>
          </p>
        </div>
      </div>

      <div class="order_details_passenger_separation flex_wrap"><h3>业务信息</h3></div>
      <template v-for="(infoItem, index) in orderData.OrderList_InfoList" v-if="orderData && orderData.OrderList_InfoList && orderData.OrderList_InfoList.length > 0">
        <div :key="index + 'i'" class="order_details_passenger_wrap">
          <div class="order_details_passenger_information flex_wrap">
            <p class="name">
              <span>姓名 :</span>
              <span>{{ infoItem.RealName }}</span>
            </p>
            <p class="type">
              <span>车票类型 :</span>
              <span>{{ infoItem.TicketType }}</span>
            </p>
            <p class="idnum">
              <span>证件号 :</span>
              <span>{{ infoItem.CardNO }}</span>
            </p>
            <template v-if="infoItem.OrderList_ServerList && infoItem.OrderList_ServerList.length > 0" v-for="(service, idx) in infoItem.OrderList_ServerList">
              <p :key="idx" class="update_service_item primaryColor-text">
                <i class="iconfont icon-iconyouxianbandengji"></i>
                <span>{{ service.ServiceName }}</span>
              </p>
            </template>
          </div>

          <div class="order_details_checking" @click="showTicketReceiptnum(infoItem)">
            <span>验票码</span>
            <i class="iconfont icon-erweima primaryColor-text"></i>
          </div>
          <template
            v-for="(freItem, j) in infoItem.OrderList_InfoFrequencyList"
            v-if="infoItem && infoItem.OrderList_InfoFrequencyList && infoItem.OrderList_InfoFrequencyList.length > 0"
          >
            <div :key="j + 's'" class="hodometer">
              <p class="separation_title">第{{ j + 1 }}程</p>
            </div>

            <div :key="j + 'a'" class="route_list flex_wrap j_c_between a_i_center">
              <div class="route_list_left flex_wrap column a_i_center">
                <span class="">{{ freItem.SetDate }}</span>
                <span class="primaryColor-text">{{ freItem.Time }}</span>
              </div>
              <div class="route_list_center flex_wrap">
                <span class="site_name_w">{{ freItem.FromPlace }}</span>
                <i class="iconreversal iconfont icon-jiantou_qiehuanyou"></i>
                <span class="site_name_w">{{ freItem.ToPlace }}</span>
              </div>
              <div class="route_list_right flex_wrap j_c_between a_i_center">
                <p class="">
                  <span class="red-text">&yen;{{ freItem.Price }}</span>
                </p>
                <button
                  :disabled="freItem.Checked || freItem.ChangeTimes > 0"
                  class="little_btn function_btn_primary_color"
                  @click="(changeModal.Show = true), (changeModal.info = infoItem), (changeModal.fre = freItem)"
                >
                  班次变更
                </button>
              </div>
            </div>
          </template>
        </div>
      </template>
    </section>
  </article>
</template>

<script>
import orderApi from '../request/orderApi';
import baseTool from '../utils/baseFunction';
export default {
  name: 'ScopeOrderDetailsInfo',
  data() {
    return {
      orderData: {},
      orderId: '',
      orderState: ['待支付', '已支付', '已完成', '发起退款', '退款成功', '等待客服']
    };
  },
  activated() {
    this.orderId = this.$route.params.id;
    this.getOrderData();
  },
  methods: {
    getOrderData() {
      let that = this;
      orderApi.getScopeOrderInfo(this.$store.state.user.OpenId, this.orderId).then(sucRes => {
        if (sucRes.success) {
          let val = sucRes.data;
          val.CreateDate = baseTool.formatDateStr(val.CreateDate, 'full'); // 2018.11.5
          val.SetDate = val.SetDate != null ? baseTool.formatDateStr(val.SetDate, 'full') : '待客服确认';
          this.orderData = val;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
@import '../style/public';

.order_details_passenger_separation {
  height: 4vh;
  line-height: 4vh;
  background-color: #E77618;
  color: #fff;
  margin-top: 1em;
  font-size: 0.35rem;
  .flex_wrap(center, center);
}
.order_details_passenger_separation > h3 {
  letter-spacing: 2px;
  text-indent: 2px;
}

.order_details_route > div {
  padding: 0 1em;
}
.order_details_route_info {
  flex-direction: column;
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  margin-top: 1em;
}
.order_details_route_info p:first-child {
  margin-top: 0.5em;
}
.order_details_route_info p {
  line-height: 4vh;
}
.order_details_route_info p:last-of-type {
  margin-bottom: 0.5em;
}
.order_details_function_btns {
  border-top: 1px dashed #888;
  padding: 0.5em 0 0;
  flex-wrap: wrap;
}
.order_details_function_btns .little_btn {
  letter-spacing: normal;
  text-indent: inherit;
  margin: 0 0.5em 0.5em 0;
  border-color: transparent;
  /*padding: 3px 4px;*/
}
.function_btn_primary_color {
  background-color: #17abe3;
  color: #fff;
}
.function_btn_primary_color:active {
  background-color: #E77618;
  color: #e4e4e4;
}
.function_btn_wx_color {
  background-color: #09bb07;
  color: #fff;
}
.function_btn_wx_color:active {
  background-color: #00b780;
  color: #e4e4e4;
}
.function_btn_pj_color {
  background-color: #e42121;
  color: #fff;
}
.function_btn_pj_color:active {
  background-color: #cc1e1e;
  color: #e4e4e4;
}

.order_details_passenger_wrap {
  border: solid #ddd;
  border-width: 1px 1px 0;
  background-color: #f8f8f8;
  margin: 10px 0;
  flex-wrap: wrap;
  box-sizing: border-box;
  .flex_wrap(space-between, initial, wrap);
}
.order_details_passenger_information {
  flex-wrap: wrap;
  flex: 0 0 75%;
  padding: 0.5em 0;
}
.order_details_checking {
  flex: 0 0 25%;
  border-left: 1px solid #ddd;
  .flex_wrap(center, center, initial, column);
}
.order_details_checking .iconfont {
  font-size: 0.6rem;
}
/*.order_details_passenger_information>.name{
  	flex: 0 0 40%;
  }
  .order_details_passenger_information>.type{
  	flex: 0 0 40%;
  }*/
.order_details_passenger_information {
  .flex_wrap(initial, initial, wrap);
}
.order_details_passenger_information > p {
  padding: 0 10px;
  line-height: 4vh;
}
.order_details_passenger_information > .update_service_item > .iconfont {
  margin-left: 0;
}
.hodometer {
  flex: 0 0 100%;
  border: solid #ddd;
  border-width: 1px 0;
}
.order_details_passenger_wrap .separation_title {
  width: inherit;
  margin: 0;
  padding: 0;
  text-align: center;
}
.route_list {
  font-size: 0.32rem;
  flex: 0 0 100%;
  border-bottom: 1px solid #ddd;
  height: 7vh;
  padding: 0.5em;
  .flex_wrap(space-between, center);
}
.route_list > div {
  /*line-height: 4vh;*/
}
.route_list_left {
  flex: 0 0 auto;
  margin-right: 0.5em;
  .flex_wrap(initial, center, initial, column);
}
.route_list_center {
  .flex_wrap;
}
.route_list_center .iconfont {
  // margin: 0 5px;
}
.route_list_right {
  .flex_wrap(space-between, center, initial);
  & > .little_btn {
    letter-spacing: normal;
    text-indent: inherit;
    border-color: transparent;
    padding: 0 5px;
    margin-right: 0;
  }
}
.order_details_passenger_wrap {
  font-size: 0.35rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ScopeOrderDetailsInfo.vue